import { Accordion, AccordionItem, cn } from '@heroui/react';
import { useFormContext } from 'react-hook-form';
import { getWeightBadgeClass, getWeightLabel, normalizeMarkWeight } from './mark-weight';
import type { IMarkSchema } from './schema';

export const StationMarksPreview = () => {
  const { getValues } = useFormContext<{ marks: IMarkSchema[] }>();
  const { marks } = getValues();
  return (
    <div className=''>
      <div className='px-2 pb-2'>
        <span className='text-lg'>Mark Scheme</span>
        &nbsp;&nbsp;(Headers: {marks.length})&nbsp; (Marks:
        {marks.reduce((acc, section) => acc + section.choices.length, 0)})
        <div className='text-xs text-default-500 mt-1'>Striked marks are excluded from AI.</div>
      </div>

      <Accordion
        defaultExpandedKeys={marks.map((section) => section.header)}
        variant='splitted'
        className='space-y-2'
        selectionMode='multiple'
      >
        {marks.map((section, index) => (
          <AccordionItem
            classNames={{
              content: 'pt-0 border-t border-default-200',
              title: 'font-medium px-4',
              base: 'shadow-none border border-default-200 rounded-md pl-0',
            }}
            key={section.header}
            title={`${index + 1}. ${section.header?.toUpperCase()}`}
          >
            {section.choices.map((choice, choiceIndex) => {
              const weightValue = normalizeMarkWeight(choice.weight);
              return (
                <div
                  key={choice.name}
                  className={cn('flex rounded-md p-2 flex-row gap-1 py-4 justify-between items-center', {
                    'border-b border-default-200': choiceIndex !== section.choices.length - 1,
                  })}
                >
                  <div className='flex flex-row gap-2 items-center px-2'>
                    <span
                      className={cn('text-xs border rounded px-2 py-0.5', getWeightBadgeClass(weightValue))}
                    >
                      {getWeightLabel(weightValue)}
                    </span>
                    <span className='text-default-500 text-sm'>#{choice.index}.</span>
                    <span
                      className={cn({
                        'line-through text-default-400': Boolean(choice.excludeFromAi),
                      })}
                    >
                      {choice.name ?? '--'}
                    </span>
                  </div>
                </div>
              );
            })}
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
